import React from 'react';
import styled from '@emotion/styled';

const NavContainer = styled.nav`
  background-color: #0052CC;
  color: white;
  padding: 16px 0;
  box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
`;

const NavContent = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: white;
  
  svg {
    width: 32px;
    height: 32px;
    transition: transform 0.2s ease;
  }
  
  &:hover svg {
    transform: scale(1.05);
  }
`;

const NavigationBar = () => {
  return (
    <NavContainer>
      <NavContent>
        <Logo>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="white"/>
            <path d="M20.5 18.5L24 22M14.5 20C17.5376 20 20 17.5376 20 14.5C20 11.4624 17.5376 9 14.5 9C11.4624 9 9 11.4624 9 14.5C9 17.5376 11.4624 20 14.5 20Z" 
              stroke="#0052CC" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"/>
            <rect x="12" y="13" width="2" height="2" rx="0.5" fill="#DEEBFF"/>
            <rect x="15" y="13" width="2" height="2" rx="0.5" fill="#DEEBFF"/>
          </svg>
          Marketplace Listing Preview
        </Logo>
      </NavContent>
    </NavContainer>
  );
};

export default NavigationBar; 